import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faculty-overview',
  templateUrl: './faculty-overview.component.html',
  styleUrls: ['./faculty-overview.component.scss']
})
export class FacultyOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
